import {ActionTree} from 'vuex';
import {AdminusStore} from '@/store/types';
import {SearchState} from '@/store/search/types';


export const actions: ActionTree<SearchState, AdminusStore> = {
    async setQueryAction({commit}, payload) {
        await commit('setQuery', payload);
    },
    async setResultsAction({commit}, payload) {

        await commit('setResult', payload);

    },

    async fillNamespacesList({commit}, payload) {
        await commit('setList', payload);
    },

};
